// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PredictedField.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

/**
 * CalculatedField Component
 */
import 'share/utils/Izenda.StringUtilities';
import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { autorun, observable, toJS } from 'mobx';
import { pure } from 'recompose';
import constants from 'logic/data/Izenda.PredictedFieldConstants';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import PredictedFieldBody from './Izenda.PredictedFieldBody';
import ObjectStateConstants from 'logic/data/Izenda.ObjectStateConstants';
import { isNil, flatten, remove, isUndefined, isEmpty, find, toLower, get } from 'lodash/fp';

class PredictedField extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    type: PropTypes.object.isRequired,
    reportPart: PropTypes.object,
    reportDesigner: PropTypes.object,
    requireLabel: PropTypes.bool,
    isCheckDuplicateWithActualField: PropTypes.bool,
    querySourceId:PropTypes.string
  };

  static defaultProps = {
    type: constants.PM_TYPES.ADD,
    requireLabel: true,
    isCheckDuplicateWithActualField: true
  };

  constructor(props: any) {
    super(props);

    this.uiStore = observable({
      showLoading: false
    });

    let { store, value = {}, type } = this.props;
    store.init();
    const model = store.clonedModel;
    store.clonedModel.name =  value.name;
    store.clonedModel.targetValue =  value.targetValue;
    store.clonedModel.selectedModel =  value.modelName;
    store.clonedModel.selectedModelType =(value.izendaDataType && value.izendaDataType!==null) ? (value.izendaDataType ==='Numeric') ? 'predict' : 'classify' : '';
    store.clonedModel.inputFeatures = value.inputFeatures;
    store.clonedModel.accuracy = value.accuracy; 
    store.clonedModel.relationColumn = value.relationColumn;
     let a = model.readInitialData(value, type);
    this.disposeAutoRun = autorun(() => store.getFormatsByType(store.clonedModel.izendaDataType));
  }

  componentWillUnmount() {
    this.disposeAutoRun();
  }

  startLoading = () => {
    this.uiStore.showLoading = true;
  };

  endLoading = () => {
    this.uiStore.showLoading = false;
  };

  /**
   * When click button OK on popup
   */
  onAcceptClosing = () => {
    const { store,loader,validation: valManager } = this.props;
      let sourceId = this.props.querySourceId;
      let fieldName = store.clonedModel.name;
      let isDeletedFromList = false;
      
      // loader.startLoading();
      if(store.clonedModel.name === ""){
     
       valManager.updateErrors([
         {
           key: constants.VALIDATION_FIELD_NAME,
           messages: String.format(constants.PM_MESSAGES.EMPTY_FIELD, store.clonedModel.name)
         }
       ]);
       return;
      }
      // console.log(store.clonedModel.selectedModel);
      if(store.clonedModel.selectedModel === undefined){
        valManager.updateErrors([
          {
            key: constants.VALIDATION_FIELD_DROPDOWN,
           messages: String.format(constants.PM_MESSAGES.EMPTY_FIELD, store.clonedModel.selectedModel)
          }
        ]);
        return;
       }
      this.fieldExistence = this.props.fieldList.filter(param => param.details.name === fieldName);
      if(this.fieldExistence.length>0){
         let fieldExists = this.fieldExistence[0];
         isDeletedFromList = fieldExists.getState() === ObjectStateConstants.DELETE && fieldExists.details.id;
         if(fieldExists.getState !== ObjectStateConstants.DELETE && fieldExists.details.id === null){
          valManager.updateErrors([
            {
              key: constants.VALIDATION_FIELD_NAME,
              messages: String.format(constants.PM_MESSAGES.DUPLICATE_NAME, store.clonedModel.name)
            }
          ]);
          return;
         }
         if(isDeletedFromList){
             //Clean up fieldlist if any issue occurs
            //this.props.fieldList.remove()
            this.fieldExistence = [];
        }
      }
      store.validatePredictedFieldExists(fieldName,sourceId).then((data)=>{
        if(data.result.izendaDataType){
          valManager.updateErrors([
            {
              key: constants.VALIDATION_FIELD_NAME,
              messages: String.format(constants.PM_MESSAGES.DUPLICATE_NAME, store.clonedModel.name)
            }
          ]);

        }else{
           this.props.onClose(store.clonedModel);
           this.props.onAccept();
           return;
        }
      }).catch((e)=>{
        console.log('ERROR------------>',e);
      }); //.finally(loader.endLoading.bind(loader));
     // loader.endLoading();
  };

  validateIzendaDataType(): Boolean {
    const { store: { clonedModel: { izendaDataType } } } = this.props;
    return isNil(izendaDataType);
  }


  /**
   * Validate not contain character '[',']' before save
   */
  validateName() {
    const model = this.props.store.clonedModel;

    return model.name && (model.name.indexOf(']') > -1 || model.name.indexOf('[') > -1);
  }

  /**
   * When click button Cancel on popup
   * @param  {Object} hidePopup function
   */
  onCancelClosing = (hidePopup: Function) => {
    this.props.validation.reset();
    hidePopup();
  };

  /**
   * Handle when popup closing
   * @param  {Object} closeCallback function
   * @param  {Object} type of close button click
   */
  onClosing = (closeCallback: Function, type: String) => {
    const hidePopup = () => {
      this.props.onAccept();
      this.props.onClose();
      closeCallback();
    };

    // close expression selection
    //this.refs.calculatedFieldContainer.closeExpressionSelection();

    if (type === 'accept') {
      return this.onAcceptClosing();
    } else if (type === 'cancel') {
      return this.onCancelClosing(hidePopup);
    }
  };
  /**
   * Update error to validation context
   */
  updateError = (errors: any) => {
    if (!isEmpty(errors)) {
      this.props.validation.updateErrors(errors);
      return false;
    }

    return true;
  };

  render() {
    let {
      localization,
      type: popupLabels,
      store,
      validation,
      reportDesigner,
      reportPart,
      expressionConfig,
      requireLabel,
      querySourceId,
    } = this.props;
    return (
      <Popup
        visible
        onClosing={this.onClosing}
        autoClose={false}
        type="none"
        sizeClass="modal-lg"
        showLoading={this.uiStore.showLoading}
      >
        <Popup.Header title={popupLabels.title} /> 
        <Popup.Body>
          <PredictedFieldBody
            ref="predictedFieldContainer"
            store={store}
            validation={validation}
            type={popupLabels}
            localization={localization}
            reportDesigner={reportDesigner}
            reportPart={reportPart}
            startLoading={this.startLoading}
            endLoading={this.endLoading}
            updateError={this.updateError}
            requireLabel={requireLabel}
            querySourceId={querySourceId}
          />
        </Popup.Body>
        <Popup.Footer>
        <Popup.ConfirmationButton key="accept" type="accept">
            {localization.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>  
          <Popup.ConfirmationButton key="cancel" type="cancel">
            {localization.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}

export default connect(pure)(PredictedField);



// WEBPACK FOOTER //
// ./ui/share/components/controls/predictedField/Izenda.PredictedField.js